module.exports = __webpack_public_path__ + "assets/political_other.dc32ec04.svg";